<template>
    <div>
        <div class="flex flex-col md:flex-row items-stretch md:items-center justify-between"
            :class="[
                size == 'small' ? '' : 'mt-4 md:mt-6',
                show_status ? 'justify-between' : 'justify-end',
            ]"
        >
            <div v-if="show_status"
                class="flex md:flex-1 items-center relative" :style="{ minHeight: '2.5rem' }"
            >
                <div class="flex items-center absolute"
                    :class="background_color"
                    v-show="submitting"
                >
                    <div class="text-blue-500 text-base w-8">
                        <i class="fas fa-spin fa-sync" aria-hidden="true"></i>
                    </div>

                    <p class="text-blue-500 uppercase tracking-widest">
                        {{ $t('Saving') }} ...
                    </p>
                </div>

                <div class="flex flex-1 items-center absolute"
                    :class="background_color"
                    v-show="saved"
                >
                    <div class="text-blue-500 text-lg w-8">
                        <i class="fas fa-check-circle mr-1" aria-hidden="true"></i>
                    </div>

                    <p class="text-blue-500 uppercase tracking-widest">
                        {{ $t('Changes saved') }}
                    </p>
                </div>

                <template v-if="show_errors">
                    <div :class="background_color"
                        v-show="status === 'error'"
                    >
                        <p class="text-red-500 mb-2">
                            {{ $t('Please fix these errors:') }}
                        </p>

                        <form-errors v-if="errors.length"
                            class="mb-2"
                            :errors="errors"
                        />
                    </div>

                    <div class="flex flex-1 items-center absolute"
                        :class="background_color"
                        v-show="status && status !== 'error'"
                    >
                        <div class="text-red-500 text-lg w-8">
                            <i class="fas fa-exclamation-triangle mr-1" aria-hidden="true"></i>
                        </div>

                        <p class="text-red-500">
                            {{ status }}
                        </p>
                    </div>
                </template>
            </div>

            <div class="flex flex-1 items-center justify-between md:justify-end">
                <a v-if="include_discard_button"
                    class="text-xs py-4 w-1/2 md:w-auto md:px-8 uppercase tracking-widest text-gray-600 hover:text-red-500"
                    href=""
                >
                    {{ $t('Discard Changes') }}
                </a>

                <button type="button" class="rounded-full bg-green-warm-600 hover:bg-green-warm-400 transition-colors duration-100 text-white uppercase text-sm tracking-widest"
                    :class="[
                        size == 'small' ? 'py-3 px-12' : 'py-3.5 px-12',
                        { 'bg-green-warm-400 hover:bg-green-warm-400' : submitting }
                    ]"
                    @click="submit"
                >
                    {{ $t(label) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FormErrors from './form-errors.vue';

export default {
    components: {
        FormErrors,
    },

    props: {
        id: {},
        method: {},
        label: { default: 'Save' },
        show_errors: { default: true },
        show_status: { default: true },
        url: {},
        background_color: { default: 'bg-gray-warm-100' },
        include_discard_button: { default: true },
        size: { default: 'normal' },
    },

    data() {
        return {
            errors: [],
            saved: false,
            status: false,
            submitting: false,
        }
    },

    methods: {
        submit() {
            let form = document.querySelector('#' + this.id);
            let data = new FormData(form);
            this.status = null;
            this.errors = [];
            this.submitting = true;

            axios.post(this.url, data)
                .takeAtLeast(this.show_status ? 500 : 0)
                .then(response => {
                    this.submitting = false;
                    this.saved = true;
                    this.$emit('saved', response.data);

                    setTimeout(() => {
                        this.saved = false;
                    }, 2000);
                }).catch(error => {
                    this.submitting = false;
                    this.saved = false;

                    if (error.response.data.errors) {
                        this.status = 'error';
                        this.errors = Object.values(error.response.data.errors);
                    } else {
                        this.status = error.response.data.message;
                        console.log(error.response.data);
                    }
                });
        },
    }
}
</script>
